import { render } from "./LightboxTemplate.vue?vue&type=template&id=8334e3c8&scoped=true"
import script from "./LightboxTemplate.vue?vue&type=script&lang=js"
export * from "./LightboxTemplate.vue?vue&type=script&lang=js"

import "./LightboxTemplate.vue?vue&type=style&index=0&id=8334e3c8&lang=scss&scoped=true"
import "./LightboxTemplate.vue?vue&type=style&index=1&id=8334e3c8&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8334e3c8"]])

export default __exports__